import { Actors as A, Tenants as T } from '@mntn/auth-types'
import { z } from 'zod'

export const NetworkResponseSchema = z.object({
  name: z.string(),
  networkId: z.number().int().positive(),
})

export const GetNetworksResponseSchema = z.object({
  data: z.array(NetworkResponseSchema),
})

export const GetNetworksRequestSchema = z.object({
  principal: T.KindSchema('advertiser').and(A.UserSchema),
})
